import React, { useState } from 'react';

import { TextInput } from '@rbilabs/components-library';

import noop from 'utils/noop';

type AddGiftCardInputProps = {
  className?: string;
  label?: string;
  initialValue?: string;
  onChange?: (value: string) => void;
  errorMessage?: string;
  onFocus?: () => void;
  'data-testid'?: string;
};

function AddGiftCardInput({
  className,
  initialValue = '',
  label = '',
  onChange = noop,
  onFocus = noop,
  errorMessage = '',
  'data-testid': dataTestId,
}: AddGiftCardInputProps) {
  //TODO: Add Gift Card Validations
  const [value, setValue] = useState(initialValue);

  function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    const changedValue = e.target.value;
    setValue(changedValue);
    onChange(changedValue);
  }

  return (
    <TextInput
      className={className}
      type="text"
      label={label}
      value={value}
      onChange={handleOnChange}
      errorMessage={errorMessage}
      onFocus={onFocus}
      autoFocus
      required
      data-testid={dataTestId}
    />
  );
}

export default AddGiftCardInput;
